import { createWeb3JsEddsa } from './createWeb3JsEddsa.mjs';

const web3JsEddsa = () => ({
  install(umi) {
    umi.eddsa = createWeb3JsEddsa();
  }
});

export { web3JsEddsa };
//# sourceMappingURL=plugin.mjs.map
